module.exports = __webpack_public_path__ + "static/media/paula.bcfeae3b.png";